import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { useHistory } from 'react-router';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './MobileTopNavigation.scss';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

type Props = {
  onNavbarToggle: Function;
};

function MobileTopNavigation({ onNavbarToggle }: Props) {
  const history = useHistory();

  const unreadWebNotificationsCount = useSelector(
    state => state.web_notifications.filter(notification => !notification?.readAt).length
  );
  const hasNotifications = Boolean(unreadWebNotificationsCount);

  const { isZoom, isChrome } = useApp();

  const handleChromeExtensionCloseClick = () =>
    window.parent.postMessage({ type: 'CLOSE_WORKPATTERNS_CHROME_EXTENSION' }, '*');

  const handleLogoClick = () => {
    if (isZoom) {
      (window as any).zoomSdk.openUrl({ url: window.location.origin });
    } else {
      history.push(PageUrls.HOME_PAGE);
    }
  };

  useEffect(() => {
    if (isChrome) window.parent.postMessage({ type: 'CONTENT_IFRAME_IS_LOADED' }, '*');
  }, []);

  const baseClassName = 'MobileTopNavigation';

  const chromeCloseBtnClasses = classnames(
    `${baseClassName}__close-chrome-btn`,
    isChrome && `${baseClassName}__close-chrome-btn--show`
  );

  return (
    <div className={baseClassName}>
      <div>
        <WpButton size="lg" variant="tertiary" onClick={() => onNavbarToggle()}>
          <WpIcon name="bars" />
        </WpButton>
        {hasNotifications && !isZoom && (
          <div className={`${baseClassName}__notification-count`} onClick={() => onNavbarToggle()}>
            {unreadWebNotificationsCount}
          </div>
        )}
      </div>
      <div className={`${baseClassName}__logo-wrapper`}>
        <div onClick={handleLogoClick}>
          <WpIllustration src={Illustrations.pi_logo_circle_red} className={`${baseClassName}__logo-wrapper__logo`} />
        </div>
      </div>
      <div className={chromeCloseBtnClasses}>
        <WpButton size="lg" variant="tertiary" onClick={handleChromeExtensionCloseClick}>
          <WpIcon name="times" />
        </WpButton>
      </div>
    </div>
  );
}

export default MobileTopNavigation;
